import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { OrderProductKeyAttributeSnapshot } from './OrderProductKeyAttributeSnapshot'
import { ShowcaseReviewReplyDto } from './ShowcaseReviewReplyDto'
/**
* Class ShowcaseReviewDto
*  Отзыв в публичной ленте карточки.
*/
export class ShowcaseReviewDto extends ActiveModel {

  /**
  * id
  * Идентификатор.  */
  @ActiveField(0)
  id: number = 0


  /**
  * rating
  * Оценка 1–5.  */
  @ActiveField(0)
  rating: number = 0


/**
  * pros
  * Достоинства.
  */
  @ActiveField()
  pros?: null | string


/**
  * cons
  * Недостатки.
  */
  @ActiveField()
  cons?: null | string


/**
  * text
  * Комментарий.
  */
  @ActiveField()
  text?: null | string


/**
  * authorName
  * Публичное имя автора («Имя Ф.» или «Покупатель», если имя скрыто).
  */
  @ActiveField('')
  authorName: string = ''


  /**
  * isVerifiedPurchase
  * Отзыв подкреплён завершённой покупкой.  */
  @ActiveField(false)
  isVerifiedPurchase: boolean = false


/**
  * @property keyAttributes
  * Ключевые атрибуты варианта (размер, цвет).  */
  @ActiveField({
    factory: [OrderProductKeyAttributeSnapshot, () => []]
  })
  keyAttributes: Array<OrderProductKeyAttributeSnapshot> = []


/**
  * imageIds
  * Фото — id ресурсов в порядке показа.  */
  @ActiveField({
    setter(model: ShowcaseReviewDto, prop: string, value: Array<string>, receiver?: ShowcaseReviewDto ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => String(v)) : value,
        
        receiver)
    }
  })
  imageIds: Array<string> = []


/**
  * date
  * Дата публикации (для своих неопубликованных — дата создания).
  */
  @ActiveField('')
  date: string = ''


  /**
  * reply
  * Ответ магазина.  */
  @ActiveField({
    factory: [ShowcaseReviewReplyDto, () => undefined]
  })
  reply?: null | ShowcaseReviewReplyDto
}
